import './App.css';
import React, { useState, useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route, Link, useLocation, useNavigate } from 'react-router-dom';
import logo from './images/AW NO BACKGROUND.png';
import couple2 from './images/couple2.jpg';
import imgOne from './images/working/one.jpg';
import imgTwo from './images/working/two.jpeg';
import imgThree from './images/working/three.JPG';
import instagramLogo from './images/instagramlogo.png';
import photoBoothImg from './images/Photo Booth.jpeg';
import LearnMore from './LearnMore';
import { useEffect as useReactEffect } from 'react';

function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    function handleScroll() {
      setScrolled(window.scrollY > 48);
    }
    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  function goto(target) {
    if (location.pathname === '/') {
      const el = document.getElementById(target);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        window.history.replaceState(null, '', '/#' + target);
      }
    } else {
      navigate('/?to=' + target);
    }
  }

  return (
    <nav className={"site-navbar" + (scrolled ? " navbar-scrolled" : "") }>
      <Link to="/" className="navbar-logo-link"><img src={logo} alt="Awaaz Events Logo" className="site-logo" /></Link>
      <div className="navbar-links-row navbar-links-centered">
        <Link to="/" className="navbar-link">Home</Link>
        <button className="navbar-link" onClick={()=>goto('services')}>Services</button>
        <button className="navbar-link" onClick={()=>goto('about')}>Our Story</button>
        <Link to="/contact" className="navbar-link">Contact</Link>
      </div>
    </nav>
  );
}

function ContactPage() {
  return (
    <section className="contact contact-fullpage">
      <h2>Contact Us</h2>
      <div className="contact-google-form">
        <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSeZ8z4rDCBUJteTcukO45hCmyT8AdQJKoTbX4429glgAr1fbQ/viewform?embedded=true" width="100%" height="1085" frameBorder="0" marginHeight="0" marginWidth="0" title="Awaaz Events Google Form">Loading…</iframe>
      </div>
    </section>
  );
}

function MainPage() {
  const location = useLocation();
  // Responsive detection for mobile
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 900);
  useEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth <= 900);
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  // Our Story fade-in feature
  const [storyVisible, setStoryVisible] = useState(false);
  const storyRef = useRef(null);
  useEffect(() => {
    if (location.pathname === "/") {
      const hash = window.location.hash || '';
      const params = new URLSearchParams(location.search);
      const toParam = params.get('to');
      const id = (hash && hash.startsWith('#')) ? hash.substring(1) : toParam;
      if (id) {
        setTimeout(() => {
          const el = document.getElementById(id);
          if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }, 150);
      }
    }
  }, [location]);
  useEffect(() => {
    const el = storyRef.current;
    if (!el) return;
    const observer = new window.IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setStoryVisible(true);
      },
      { threshold: 0.23 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
  // Services animation logic
  const servicesRef = useRef(null);
  const [serviceSectionVisible, setServiceSectionVisible] = useState(false);
  const cardRefs = [useRef(null), useRef(null), useRef(null), useRef(null)];
  const [cardVis, setCardVis] = useState([false, false, false, false]);
  useEffect(() => {
    // Desktop: Animate all cards when section visible
    if (!isMobile) {
      const observer = new window.IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) setServiceSectionVisible(true);
        },
        { threshold: 0.18 }
      );
      if (servicesRef.current) observer.observe(servicesRef.current);
      return () => observer.disconnect();
    } else {
      // Mobile: Animate each card when visible
      const observers = cardRefs.map((ref, i) =>
        new window.IntersectionObserver(([entry]) => {
          if (entry.isIntersecting) setCardVis(v => {
            const clone = v.slice();
            clone[i] = true;
            return clone;
          });
        }, { threshold: 0.25 })
      );
      cardRefs.forEach((ref, i) => {
        if (ref.current) observers[i].observe(ref.current);
      });
      return () => { observers.forEach(o => o.disconnect()); };
    }
  }, [isMobile]);
  // Change Learn More button handler to navigate programmatically
  const navigate = useNavigate();
  return (
    <div>
      <Navbar />
      {/* Section 1 - Hero/Text/Logo - mobile vs desktop split */}
      {isMobile ? (
        <>
          <section className="mobile-hero-block">
            <div className="hero-mobile-glass">
              <img src={logo} alt="Awaaz Events Logo" className="hero-logo-large" />
              <h1>Focus on Impressing. <br /> Not Stressing.</h1>
              <p>Your wedding, your way</p>
              <Link to='/contact' className='lets-chat-btn'>Let's Chat!</Link>
            </div>
          </section>
          <section className="mobile-hero-img-section">
            <img src={couple2} alt="Wedding Couple" className="mobile-hero-img" />
          </section>
        </>
      ) : (
        <section className="parallax-hero" style={{ backgroundImage: `url(${couple2})` }}>
          <div className="hero-overlay">
            <div className="hero-content-overlay hero-abs-left hero-desktop-glass">
              <img src={logo} alt="Awaaz Events Logo" className="hero-logo-large" />
              <h1>
                Focus on Impressing.<br />
                Not Stressing.
              </h1>
              <p>Your wedding, your way</p>
              <Link to='/contact' className='lets-chat-btn'>Let's Chat!</Link>
            </div>
            <div className="hero-flex-container">
              <HeroTestimonials />
            </div>
          </div>
        </section>
      )}

      {/* Our Services Section (centered title & cards) */}
      <section className="packages" id="services" ref={servicesRef}>
        <h2 className="services-title-centered">Our Services</h2>
        <div className="service-list-modern">
          {[
            {
              img: imgTwo, title: "Professional MC", items: ["Brings the energy and elegance to your event", "Keeps your event flowing smoothly", "Keeps the audience engaged and entertained!"]
            },
            {
              img: imgOne, title: "Wedding Coordination", items: ["Starting 2-3 months in advance of your event", "Timeline development for all events", "Handling all vendor communication"]
            },
            {
              img: imgThree, title: "Wedding Planning", items: ["Vision, vendor, and design consulting", "Budget management and expert scheduling", "Guidance from first idea to final send-off"]
            },
            {
              img: photoBoothImg, title: "Photo Booth", items: ["Modern, high-quality digital booth", "Unlimited prints & instant sharing", "Custom props and backdrops for fun memories"], className:'photobooth-img'
            }
          ].map((svc, i) => (
            <div
              key={svc.title}
              className={"service-card-modern" + (isMobile ? (cardVis[i] ? ' pop-in' : '') : (serviceSectionVisible ? ' pop-in' : ''))}
              ref={cardRefs[i]}
            >
              <div className="service-img-box">
                <img src={svc.img} alt={svc.title} className={`service-img${svc.className ? ' '+svc.className : ''}`} />
              </div>
              <div className="service-content">
                <h3>{svc.title}</h3>
                <ul>{svc.items.map((item, idx) => <li key={idx}>{item}</li>)}</ul>
              </div>
            </div>
          ))}
        </div>
        <div className="services-actions-row">
          <button className="learn-more-btn" onClick={e => { e.preventDefault(); e.stopPropagation(); navigate('/learn-more'); }}>Learn More</button>
          <Link to='/contact' className='lets-chat-btn'>Let's Chat!</Link>
        </div>
      </section>

      <div className="event-banner-bar">
        <div className="event-banner-track">
          <span>Nikkah</span>
          <span>Mehndi</span>
          <span>Reception</span>
          <span>Holud</span>
          <span>Shaadi</span>
          <span>Walima</span>
          <span>Sangeet</span>
          <span>Baraat</span>
          <span>Anand Karaj</span>
          <span>Engagement</span>
          <span>Anniversary</span>
          <span>Haldi</span>
          <span>Sagan</span>
        </div>
      </div>

      {/* Our Story Section as third main section (single page) */}
      <div
        className={`story-fade-section${storyVisible ? " story-fade-in" : ""}`}
        ref={storyRef}
      >
        <section className="about story-section" id="about" style={{maxWidth: '1100px', margin: '0 auto 64px auto', paddingTop: '60px'}}>
          <div className="story-flex-container">
            <div className="tv-visual">
              <div className="tv-frame">
                <div className="tv-screen">
                  <img src={logo} alt="Old TV with Awaaz logo" className="tv-logo-img" />
                  <div className="tv-scanlines"></div>
                  <div className="tv-tuning-bar"></div>
                </div>
                <div className="tv-antennas">
                  <div className="antenna-left"></div>
                  <div className="antenna-right"></div>
                </div>
              </div>
            </div>
            <div className="story-text-full">
              <h2 className="story-section-title">Our Story</h2>
              <div className="story-text-block">
                <p>My name is Mohammed Ali and I was a local news anchor in Blacksburg, VA. A close friend once asked me to MC their wedding, and as soon as I picked up the mic, I discovered the power of a strong voice in creating unforgettable moments. The word <b>Awaaz</b> means "voice" in Urdu, and just like a live TV show, weddings need a clear voice to keep everything seamless, fluid, and elegant. Family and guests should know what’s happening, feel connected, and enjoy a well-coordinated experience.</p>
                <p>This belief inspired us to expand Awaaz Events to include an Event Coordination Team, blending the perfect harmony of voice and organization. Together, we ensure your wedding is as polished and memorable as a live TV production.</p>
                <p><b>Let’s make your celebration unforgettable. Contact us today to bring your vision to life.</b></p>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* Contact Section */}
      <section className="contact" id="contact">
        <h2>Contact Us</h2>
        <div className="contact-btn-outer">
          <Link to="/contact" className="lets-chat-btn">Let's Chat!</Link>
        </div>
      </section>

      {/* Footer with Instagram */}
      <footer className="footer-social">
        <a href="https://instagram.com/AwaazEvents" target="_blank" rel="noopener noreferrer" className="instagram-link">
          <span className="instagram-icon" aria-hidden="true" role="img">
            <img src={instagramLogo} alt="Instagram logo" className="ig-logo-img" />
          </span>
          <span style={{marginLeft:'12px'}}>@AwaazEvents</span>
        </a>
        <div className="copyright-text">© 2026 Awaaz Events, LLC. All Rights Reserved.</div>
      </footer>
    </div>
  );
}

function LearnMoreScrollToTop() {
  useReactEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return null;
}

const testimonials = [
  "Ali was a great MC—our reception was lively and fun! – MC Client",
  "We loved how Ali kept the audience engaged and entertained! – MC Client",
  "Our timeline ran perfectly thanks to Ali and Awaaz Events Team. – Coordination Client",
  "We loved the custom photo backdrop! – Photo Booth Client",
  "All our guests raved about the photobooth. – Photo Booth Client",
  "So organized and smooth, even with 300 guests! The Awaaz Events Team is the best. – Coordination Client",
  "Ali brought so much energy and kept the party moving! – MC Client",
  "Our photos look incredible thanks to the extra lighting. – Photo Booth Client",
  "From setup to send-off, Awaaz Events Team handled every detail. – Coordination Client",
  "Ali and the Awaaz Events Team worked wonderfully with our vendors. – Coordination Client",
  "Guests had a blast with the props and instant digital photos. – Photo Booth Client",
  "As a couple, we got to ENJOY our day while Ali coordinated everything behind the scenes. – Coordination Client",
  "Everyone could hear Ali all event long—so professional and clear! – MC Client",
  "The print photo album is such a treasured keepsake. – Photo Booth Client",
  "Coordination was exceptional, we felt VIP all day. Ali made the whole process easy. – Coordination Client"
];

const venues = [
  "Willard InterContinental DC",
  "The Watergate Hotel",
  "Grand Hyatt Washington",
  "The Ritz-Carlton, Pentagon City",
  "Omni Shoreham Hotel",
  "Hilton McLean Tysons Corner",
  "The Line Hotel DC",
  "The Mayflower Hotel",
  "Salamander Washington DC",
  "The Westin Alexandria",
  "JW Marriott Washington DC",
  "The Fairfax at Embassy Row",
  "Gaylord National Resort",
  "The Madison Hotel",
  "Hyatt Regency Bethesda"
];

const months = [
  "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"
];
const years = [2021, 2022, 2023, 2024, 2025];

function HeroTestimonials() {
  const [currentIdx, setCurrentIdx] = useState(0);
  const [fadeState, setFadeState] = useState('fade-in');

  useEffect(() => {
    let showTimeout, hideTimeout;
    hideTimeout = setTimeout(() => setFadeState('fade-out'), 4500); // Start fade out before switch
    showTimeout = setTimeout(() => {
      setCurrentIdx(idx => (idx + 1) % testimonials.length);
      setFadeState('fade-in');
    }, 5000);
    return () => { clearTimeout(showTimeout); clearTimeout(hideTimeout); };
  }, [currentIdx]);

  const idx = currentIdx;
  const client = testimonials[idx].match(/– (.+)$/)?.[1];
  const dateStr = months[idx % months.length] + " " + years[idx % years.length];

  return (
    <div className="hero-testimonial-box-list single">
      <div
        key={idx}
        className={`hero-testimonial-bubble ${fadeState}`}
      >
        “{testimonials[idx].replace(/ – .+$/, "”")}
        <div className="client">{client}</div>
        <div className="date">{dateStr}</div>
      </div>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/learn-more" element={<><LearnMoreScrollToTop /><Navbar /><LearnMore /></>} />
        <Route path="/contact" element={<><Navbar /><ContactPage /></>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;